export const authUrls = {
    login: '/authentication/api/v1/auth/initiate',
    sendOtp: '/authentication/api/v1/auth/otp/send',
    verifyOtp: '/authentication/api/v1/auth/otp/verify',
};

export const dealerUrls = {
    dashboardDashboard: 'api/mpos/dealer-dashboard',
};

export const newPlanUrls = {
    documentUpload: 'api/mpos/upload',
};

export const partnershipDealerUrls = {
    dashboardDashboard: 'auto-insurance/mpos/dashboard/orders',
    order: 'auto-insurance/mpos/order',
};
